import { AccountCleanupReports } from '@/features/account-cleanup/account-cleanup-reports';
import { UserAuditSection } from '@/features/user-audit/user-audit-section';

const AccountCleanupPage = () => (
  <UserAuditSection>
    <AccountCleanupReports />
  </UserAuditSection>
);
AccountCleanupPage.displayName = 'AccountCleanupPage';

export default AccountCleanupPage;
